var minicartobserver = document.querySelector("#price-minicart");

function updateProgressBar() {
  let totalCart = parseFloat(
    document.querySelector("#price-minicart").innerText
      .replace("R$", "")
      .replace(".", "")
      .replace(",", ".")
      .trim()
  );

  let progressBar = document.getElementById("progress-on-progress-bar");
  let textProgressBar = document.getElementById("title-progress-bar");
  // let freeShipping = document.querySelector(".shipping-free-cal");
  // let shippingSearch = document.getElementById("shipping_rates");

  if (totalCart >= 240) {
    progressBar.style.width = "100%";
    textProgressBar.innerText = `Uhu! Frete grátis ✨`;
  } else {
    let progressBarQtnTotal = (totalCart * 100) / 240;
    progressBar.style.width = `${progressBarQtnTotal}%`;
    let valFrete = (240 - totalCart).toFixed(2);
    textProgressBar.innerText = `mais R$${valFrete.replace(".", ",")} e ganhe frete grátis`;
  }
}

document.addEventListener("DOMContentLoaded", updateProgressBar);

var observerb = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    updateProgressBar();
  });
});

var config = { attributes: true, childList: true, characterData: true };
observerb.observe(minicartobserver, config);
